export const URI_API_EXTTUNELL = '/exttunnel';
export const URI_API_SEARCH_GOODS = '/searchWSmaterial';
